import { Spacer } from '@jfs/ui-new'
import { emailOrBlankString, mobileNumberOrBlank, numberValidationWithDecimal } from '@jfs/utils'
import { ReactElement } from 'react'
import { TimePicker } from '../../../comps/TimePicker'

export const createPaymentLinkForm = (
  leftHeaderTextbox: ReactElement,
  checkboxWithLeftHeader: ReactElement,
  backgroundSeparator: ReactElement,
  reviewPaymentLinkSelected: boolean,
  reviewPaymentLinkInformation: ReactElement,
) => {
  return [
    {
      formItems: [
        {
          fieldName: 'backgroundSeparator1',
          ComponentName: backgroundSeparator,
        },
        {
          fieldName: 'amountField',
          ComponentName: leftHeaderTextbox,
          textLabel: 'Amount*',
          validationSchema: numberValidationWithDecimal,
          maxLength: 8,
          placeholder: '0.00',
          hide: reviewPaymentLinkSelected,
          extraDescription: 'Enter the amount to be collected.',
          testID: 'amountField',
        },
        // {
        //   fieldName: 'partialPayment',
        //   ComponentName: checkboxWithLeftHeader,
        //   checkboxText: 'Enable partial Payment',
        //   hide: reviewPaymentLinkSelected,
        // },
        {
          fieldName: 'paymentForField',
          ComponentName: leftHeaderTextbox,
          multiline: true,
          extraDescription: 'This will be visible to the customer',
          textLabel: 'Payment For',
          placeholder: 'Mention what this payment request is for.',
          maxLength: 250,
          hide: reviewPaymentLinkSelected,
          testID: 'paymentForField',
        },
        {
          fieldName: 'mobileNumber',
          ComponentName: leftHeaderTextbox,
          textLabel: 'Customer Mobile \nNumber',
          placeholder: '9876543210',
          validationSchema: mobileNumberOrBlank,
          maxLength: 10,
          hide: reviewPaymentLinkSelected,
          extraDescription: 'Enter the mobile number to which the collect link SMS has to be sent.',
          testID: 'mobileNumber',
        },
        {
          fieldName: 'email',
          ComponentName: leftHeaderTextbox,
          textLabel: 'Customer Email-ID',
          placeholder: 'abcd@xyz.com',
          validationSchema: emailOrBlankString,
          maxLength: 45,
          hide: reviewPaymentLinkSelected,
          extraDescription: 'Enter the Email ID to which the collect link has to be sent.',
          testID: 'email',
        },
        {
          fieldName: 'expiry',
          ComponentName: checkboxWithLeftHeader,
          checkboxText: 'Default Expiry (90 Days)',
          textLabel: 'Expiry On',
          hide: reviewPaymentLinkSelected,
        },
        {
          fieldName: 'timer',
          ComponentName: TimePicker,
          hide: reviewPaymentLinkSelected,
        },
        {
          fieldName: 'invoice',
          ComponentName: leftHeaderTextbox,
          textLabel: 'Invoice Number',
          placeholder: '12345',
          maxLength: 15,
          hide: reviewPaymentLinkSelected,
          extraDescription: 'Enter a unique invoice number to be associated with this request.',
          testID: 'invoice',
        },
        {
          fieldName: 'reviewPaymentLinkInformation',
          ComponentName: reviewPaymentLinkInformation,
          hide: !reviewPaymentLinkSelected,
        },
        {
          fieldName: 'backgroundSeparator2',
          ComponentName: backgroundSeparator,
        },
        {
          fieldName: 'spacer5',
          ComponentName: Spacer,
          size: 1,
        },
      ],
      actionTitle: 'FILTER',
      onSubmit: () => {
        return 'end'
      },
    },
  ] as Array<any>
}
